import { useQuery } from '@tanstack/react-query';

import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';
import { getParticipantsSprintsQueryKey } from 'api/utils';

import { mapSprints } from 'features/sprint/utils';
import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';
import { useUserId } from 'features/user/hooks/useUserId';

export const useParticipantsSprintsQuery = (options = {}) => {
  const userMode = useUserMode();
  const { request } = useQueryHTTPRequest();
  const userId = useUserId();

  return useQuery(
    getParticipantsSprintsQueryKey(userId),
    ({ signal }) =>
      request({ url: `/api/timeline/sprints?user_id=${userId}`, signal }),
    {
      staleTime: 5 * 1000,
      cacheTime: 10 * 1000,
      refetchOnMount: false,
      ...options,
      enabled: !!userId && userMode !== USER_MODES.users,
      select: (data) =>
        mapSprints({
          sprints: Array.isArray(data?.sprints) ? data.sprints : [],
        }),
    }
  );
};
